import axios from "axios";
import React, { useState } from "react";
import { Button, Modal } from 'react-bootstrap';
import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";

export default function AddEtude({ idCv }) {
    const [show, setShow] = useState(false);
    const navigate = useNavigate();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [etude, setEtude] = useState('');
    const [datecole, setDatecole] = useState('2023');
    const [datefinecole, setDateFinEcole] = useState('2024');
    const [descrEcole, setDescrEcole] = useState('');

    const datable = Array.from({ length: 51 }, (_, i) => (1990 + i).toString());

    const handleEcole = async () => {
        const dataEc = new FormData();
        dataEc.append('ecole', etude);
        dataEc.append('datecole', datecole);
        dataEc.append('datefinecole', datefinecole);
        dataEc.append('descriptionecole', descrEcole);
        dataEc.append('cv_id', idCv);

        try {
            const resp = await axios.post('diplomes', dataEc);
            if (resp.status === 201) {
                NotificationManager.success('École enregistrée avec succès', 'Succès', 4000);
                navigate(`/cv/${idCv}`);
                // navigate(`/editCv/${idCv}`);
            } else {
                NotificationManager.warning('Une erreur est survenue', 'Erreur', 4000);
            }
        } catch (error) {
            NotificationManager.error('Erreur lors de l\'enregistrement', 'Erreur', 4000);
            console.error(error);
        }
    };

    return (
        <>
            <Button variant="info" onClick={handleShow}>
                <b>+</b> Ajouter une école
            </Button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Ajouter une école</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="form-group">
                            <label className="form-label">Nom de l'école</label>
                            <input
                                required
                                value={etude}
                                onChange={(e) => setEtude(e.target.value)}
                                maxLength={50}
                                className="form-control mb-2"
                                type="text"
                                placeholder="École"
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label">Date de début et de fin</label>
                            <div className="input-group">
                                <select
                                    value={datecole}
                                    onChange={(e) => setDatecole(e.target.value)}
                                    className="form-control"
                                >
                                    {datable.map((date) => (
                                        <option value={date} key={date}>{date}</option>
                                    ))}
                                </select>
                                <select
                                    value={datefinecole}
                                    onChange={(e) => setDateFinEcole(e.target.value)}
                                    className="form-control"
                                >
                                    {datable.map((date) => (
                                        <option value={date} key={date}>{date}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="form-label">Description de votre cursus</label>
                            <textarea
                                required
                                value={descrEcole}
                                onChange={(e) => setDescrEcole(e.target.value)}
                                className="form-control mb-2"
                                placeholder="Description de votre cursus"
                                rows="3"
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={handleEcole}>
                        Enregistrer
                    </Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Fermer
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
